<div [class.login-page]="!isLoggedIn">
  @if (isLoggedIn) {
    <app-topnav [llttfPage]="llttfPage"></app-topnav>
  }
  @if (!isLoggedIn) {
    <app-top-nav-login [bbApp]="true"></app-top-nav-login>
  }

  @if (!isLoggedIn) {
    <div class="about-us__province-banner">
      <div class="container">
        <h2 class="about-us__title">{{ 'aboutUsText' | translate:translations }}</h2>
        <p class="about-us__province-label">{{ 'aboutUsSelectProvince' | translate:translations }}</p>
        <div
          class="about-us__province-toggle"
          role="group"
          [attr.aria-label]="'aboutUsSelectProvince' | translate:translations">
          @for (province of provinceOptions; track province) {
            <button
              type="button"
              class="about-us__province-btn"
              [class.about-us__province-btn--active]="isSelectedProvince(province.id)"
              [attr.aria-pressed]="isSelectedProvince(province.id)"
              (click)="selectProvince(province.id)">
              {{ province.labelKey | translate:translations }}
            </button>
          }
        </div>
      </div>
    </div>
  }

  <div class="container">
    <div class="content" role="main">
      <div class="cmha-dashboard">
        @if (isLoggedIn) {
          <div class="participant-banner" [ngClass]="bannerClass">
            <div class="container">
              <h2>{{ 'aboutUsText' | translate:translations }}</h2>
            </div>
          </div>
        }
        @if (isLoggedIn) {
          <div class="h-30"></div>
        }
        <div class="container" [class.about-us__guest-content]="!isLoggedIn">
          @if (content) {
            <div class="about-us__content" [innerHTML]="content"></div>
          }
        </div>

        <div class="h-30"></div>
      </div>
    </div>
  </div>

  @if (isLoggedIn) {
    <app-footer></app-footer>
  }
  @if (!isLoggedIn) {
    <app-footer [bbapp]="true" [showLogos]="true" [showBrandImage]="false"></app-footer>
  }
</div>
